import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";

import LogoNavigation from "./Icons/LogoNavigation/index";

import { loadUser, removeSessionToken } from "../store/localStorage";
import theme from "./styles/theme/theme";
import { AppDispatch } from "../store/store";
import { setCaricomCountry } from "../features/map/mapSlice";
import { clearCountriesPerUser } from "../features/countries/countriesPerUserSlice";

interface NavigationProps {
  isMenuHidden?: boolean;
}

type NavigationItem = "admin_panel" | "logout";
const navigationItems: NavigationItem[] = ["admin_panel", "logout"];

const Navigation: React.FC<NavigationProps> = ({
  isMenuHidden,
}: NavigationProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const loggedUser = loadUser();

  const [avatarChart, setAvatarChart] = useState("");

  useEffect(() => {
    const firstChart = loggedUser?.email.charAt(0).toUpperCase();
    firstChart && setAvatarChart(firstChart);
  }, [loggedUser?.email]);

  const [isNavOpen, setIsNavOpen] = React.useState(false);

  const handleLogout = async () => {
    removeSessionToken();
    dispatch(setCaricomCountry(undefined));
    dispatch(clearCountriesPerUser());
    navigate("/login");
  };

  const handleMenuClick = (value: NavigationItem) => {
    if (value === "logout") {
      handleLogout();
    } else if (value === "admin_panel" && loggedUser?.isAdmin) {
      navigate("/admin-panel");
    }
    setIsNavOpen(false);
  };

  return (
    <Box
      sx={{
        marginBottom: "24px",
        backgroundColor: "secondary.600",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: `0 ${isSmScreen ? "10px" : "50px"}`,
        }}
      >
        <Link href="/" sx={{ color: theme.palette.common.white }}>
          <LogoNavigation
            color={theme.palette.common.white}
            width="90px"
            height="30px"
          />
        </Link>
        {!isMenuHidden && (
          <Box className='hidden-print'>
            <Tooltip title={t("menu.open_menu")}>
              <IconButton onClick={() => setIsNavOpen(true)} sx={{ p: 0 }}>
                <Avatar
                  sx={{
                    backgroundColor: theme.palette.common.white,
                    marginRight: "10px",
                    color: theme.palette.primary.main,
                  }}
                >
                  {avatarChart}
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={isNavOpen}
              onClose={() => setIsNavOpen(false)}
            >
              {navigationItems.map((value) =>
                value === "admin_panel" && !loggedUser?.isAdmin ? null : (
                  <MenuItem key={value} onClick={() => handleMenuClick(value)}>
                    <Typography textAlign="center">
                      {t(`menu.${value}`)}
                    </Typography>
                  </MenuItem>
                )
              )}
            </Menu>
          </Box>
        )}
      </Toolbar>
    </Box>
  );
};

export default Navigation;
